import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from 'common/components/antd/Button/Button';
import { ReactComponent as NoMatchIcon } from 'assets/404.svg';
import { SContainer, SDescription, SMainContainer, STitle } from './404.page.styles';

const NoMatchPage = (): ReactElement => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <SMainContainer>
      <SContainer>
        <NoMatchIcon />
        <STitle>{t('page404.title')}</STitle>
        <SDescription>
          {t('page404.description.line1')}<br/>
          {t('page404.description.line2')}
        </SDescription>
        <Button
          type="primary"
          size="large"
          width={324}
          onClick={(): void => {
            navigate(-2);
          }}
        >
          {t('page404.button.goBack')}
        </Button>
      </SContainer>
    </SMainContainer>
  );
}

export default NoMatchPage;
